import React from 'react';
import Toaster, { raiseToast } from '../../../components/Toaster';
import SystemToast from '../../../components/SystemToast';
import request from '../../../utils/request';
import { getAuthToken } from '../../../utils/auth';
import { api } from '../../../utils/url';

const resourceType = 'lineitems';

export function createLineItem(lineItem) {
  return async () => {
    const authHeader = getAuthToken();

    const options = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${authHeader}`,
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin'
    };

    if (lineItem) {
      options.body = JSON.stringify({
        data: [lineItem]
      });
    }

    try {
      const url = api(`/lineitems`);

      const response = await request(url, options);

      return response;
    } catch (err) {
      raiseToast(<SystemToast type={SystemToast.Type.ERROR} message={`Unable to access ${resourceType}`} />, {
        position: Toaster.Position.BOTTOM_LEFT
      });

      throw err;
    }
  };
}

export function createLineItemsV2(lineItems) {
  return async () => {
    const authHeader = getAuthToken();

    const options = {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${authHeader}`,
        'da-api-version': 2,
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin'
    };

    if (lineItems) {
      options.body = JSON.stringify({
        data: lineItems
      });
    }

    try {
      const url = api(`/lineitems`);

      const response = await request(url, options);

      return response;
    } catch (err) {
      raiseToast(<SystemToast type={SystemToast.Type.ERROR} message="Unable to create line items" />, {
        position: Toaster.Position.BOTTOM_LEFT
      });

      throw err;
    }
  };
}

export function updateLineItems(lineItems) {
  return async () => {
    const authHeader = getAuthToken();

    const options = {
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${authHeader}`,
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin'
    };

    if (lineItems) {
      options.body = JSON.stringify({
        data: lineItems
      });
    }

    try {
      const url = api(`/lineitems`);

      const response = await request(url, options);

      return response;
    } catch (err) {
      raiseToast(<SystemToast type={SystemToast.Type.ERROR} message={`Unable to update ${resourceType}`} />, {
        position: Toaster.Position.BOTTOM_LEFT
      });

      throw err;
    }
  };
}

export function updateLineItemCalculationsUsingNightlyJobLogicById(id, name) {
  return async () => {
    try {
      const url = api(`/system-calculate-line-item/${id}`);
      return await request(url, { method: 'POST' });
    } catch (err) {
      raiseToast(
        <SystemToast type={SystemToast.Type.ERROR} message={`Unable to update line item calculation form ${name}`} />,
        {
          position: Toaster.Position.BOTTOM_LEFT
        }
      );

      throw err;
    }
  };
}

export function updateLineItemCalculationsById(id, name) {
  return async () => {
    try {
      const url = api(`/system-calculate-line-item/${id}`);
      return await request(url, { method: 'POST' });
    } catch (err) {
      raiseToast(
        <SystemToast type={SystemToast.Type.ERROR} message={`Unable to update line item calculation form ${name}`} />,
        {
          position: Toaster.Position.BOTTOM_LEFT
        }
      );

      throw err;
    }
  };
}

export function retrieveLineItemsCalculationsById(id) {
  return async (setState) => {
    try {
      const url = api(`/system-calculate-line-item/${id}/calculations`);

      const response = await request(url);
      setState((prevState) => {
        const newState = {
          ...prevState,
          'lineItem.id': {
            ...prevState['lineItem.id'],
            [response.data.id]: response.data
          }
        };
        return newState;
      });
      return response;
    } catch (err) {
      raiseToast(<SystemToast type={SystemToast.Type.ERROR} message="Unable to retrieve line item calculations" />, {
        position: Toaster.Position.BOTTOM_LEFT
      });

      throw err;
    }
  };
}

export function retrieveLineItemAccessorialCalculations(type, orderId, legId) {
  return async () => {
    try {
      const url = api(`/lineitems/accessorial-calculations`);
      const options = {
        query: {
          type,
          orderId,
          legId
        }
      };

      const response = await request(url, options);

      return response;
    } catch (err) {
      raiseToast(
        <SystemToast type={SystemToast.Type.ERROR} message="Unable to retrieve line item accessorial calculations" />,
        {
          position: Toaster.Position.BOTTOM_LEFT
        }
      );

      throw err;
    }
  };
}
